export const UPDATE_MAKE_OFFER_MODAL_SHOWN = 'UPDATE_MAKE_OFFER_MODAL_SHOWN';

export function updateMakeOfferModalShown(shown) {
    return { type: UPDATE_MAKE_OFFER_MODAL_SHOWN, makeOfferModalShown: shown };
}
